import script from "./SpecialRuleEdit.vue?vue&type=script&setup=true&lang=ts&name=SpecialRuleEdit"
export * from "./SpecialRuleEdit.vue?vue&type=script&setup=true&lang=ts&name=SpecialRuleEdit"

const __exports__ = script;

export default __exports__